<template>
  <div class="flex">
    <div v-for="(step, stepId) in steps" :key="stepId"
      class="flex flex-col flex-1 text-center cnt-stepper-item items-center">
      <component :is="icon(step.status)" class="h-4 w-4 z-10"></component>
      <span v-if="step.status === STATUS_UPCOMING" class="h-4 w-4 rounded-full border-semitone-primary-1 border bg-white z-10" aria-hidden="true" />
      <p class="mt-2 text-body-7 font-medium text-primary-1">{{ step.name ?? 'Step ' + (stepId + 1) }} </p>
    </div>
  </div>
</template>
<script setup>
import CheckedCircle from '@/components/icons/CheckedCircle.vue';
import EmptyCircle from '@/components/icons/EmptyCircle.vue';

const STATUS_COMPLETE = 'complete';
const STATUS_CURRENT = 'current';
const STATUS_UPCOMING = 'upcoming';

const props = defineProps(['steps']);

const icon = function(status) {
    if (status === STATUS_CURRENT) {
        return EmptyCircle;
    }

    if (status === STATUS_COMPLETE) {
        return CheckedCircle;
    }

    return null;
}

</script>
